function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import PageContent from '@profile/src/Components/PageContent';
import ItemCard from './ItemCard';
import Spinner from '@profile/src/Components/Spinner';
import { fetchCosmeticConfigs, fetchUserGiftBoxList } from '@profile/src/redux/actions';
import { getBoxConfig } from '@main/src/redux/remoteActions';
import { useTypedDispatch, useTypedSelector } from '@profile/src/redux/utils';
import { AppError } from '@profile/src/redux/types';
import ErrorViewV2 from '@profile/src/Components/ErrorViewV2';
import { ErrorViewType } from '@profile/src/Components/ErrorViewV2/config';
import OpenThetanBoxProvider from '@profile/src/Profile_V2/OpenThetanBoxProvider';
import { TestableProvider, useTestId } from '@wolffun/testable-id';

const GiftBoxTab = ({
  className
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  const dispatch = useTypedDispatch();
  const {
    data,
    isInstalledGame
  } = useTypedSelector(state => state.giftBoxList);
  const boxConfigs = useTypedSelector(state => {
    var _state$boxConfigsV2$d;

    return (_state$boxConfigsV2$d = state.boxConfigsV2.data) === null || _state$boxConfigsV2$d === void 0 ? void 0 : _state$boxConfigsV2$d.boxConfigs;
  });
  const invalidated = useTypedSelector(state => state.giftBoxList.invalidated);
  const loading = useTypedSelector(state => state.giftBoxList.loading);
  const error = useTypedSelector(state => state.giftBoxList.error);
  const onRefresh = React.useCallback(() => {
    dispatch(fetchUserGiftBoxList());
    dispatch(getBoxConfig());
    dispatch(fetchCosmeticConfigs());
  }, [dispatch]);
  React.useEffect(() => {
    onRefresh();
  }, [onRefresh]);

  const renderContent = () => {
    const totalItem = data.reduce((prev, e) => {
      return prev + e.amount;
    }, 0);
    return /*#__PURE__*/React.createElement(TestableProvider, {
      testId: "other-box"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.header
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.title
    }, /*#__PURE__*/React.createElement("span", _extends({}, generateTestIdProps('other-box', 'total'), {
      className: styles.spanTitle
    }), "Items:\xA0", /*#__PURE__*/React.createElement("span", null, totalItem)))), /*#__PURE__*/React.createElement("div", {
      className: styles.content
    }, data.map(box => {
      if (!boxConfigs || !box) return undefined;
      const config = boxConfigs[box.boxType]; // FM LOGIC: hide empty box types to avoid displaying a lot of ended seasonal boxes

      const shouldDisplayBox = box && (box.amount > 0 || box.processing > 0);
      if (box && shouldDisplayBox) return /*#__PURE__*/React.createElement(ItemCard, {
        className: styles.item,
        isInstalledGame: isInstalledGame,
        item: box,
        config: config,
        key: box.boxType.toString()
      });
      return undefined;
    })));
  };

  const renderError = () => {
    return /*#__PURE__*/React.createElement(ErrorViewV2, {
      config: {
        content: 'Please try again.',
        type: ErrorViewType.Custom,
        title: 'Sorry, something went wrong'
      },
      className: styles.empty
    });
  };

  const renderLoading = () => {
    return /*#__PURE__*/React.createElement(Spinner, {
      className: styles.spinner
    });
  };

  return /*#__PURE__*/React.createElement(OpenThetanBoxProvider, {
    onRefresh: onRefresh
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement(PageContent, {
    invalidated: invalidated,
    loading: loading,
    error: error !== AppError.NO_ERROR,
    renderContent: renderContent,
    renderLoading: renderLoading,
    renderError: renderError
  })));
};

export default GiftBoxTab;